
import { defineComponent, PropType } from 'vue'
import { IntegrationShortcodes } from '~/mixins/integrationsDetailMixin'
import { descriptionMap } from '~/types/integrations'

export default defineComponent({
  name: 'IntegrationTitle',

  props: {
    pending: {
      type: Boolean,
      default: false
    },
    loadingStateDimensions: {
      type: String,
      default: 'w-6 h-6'
    },
    logo: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    shortcode: {
      type: String as PropType<IntegrationShortcodes>,
      required: true
    }
  },

  data() {
    return {
      descriptionMap
    }
  }
})
